<app-two-column-structure
    [field]="field"
    [attributeLabels]="attributeLabels"
    [moduleName]="moduleName"
    [dateFormat]="dateFormat"
    [showHrLine]="shouldDisplayHrLine(field)"
    >
</app-two-column-structure>
